import { FC } from 'react';
import { useAdvertCardContext } from '#advert/components/card';
import advertCardFooterCss from '../assets/advert-card-footer.module.scss';

const FooterPrice: FC = () => {
  const { advert } = useAdvertCardContext();

  if (!advert.price) {
    return null;
  }

  return (
    <div className={advertCardFooterCss.advertCardFooter__price}>
      {advert.price}
    </div>
  );
};

export { FooterPrice };
